import React, { useEffect } from "react";
import {
  Grid,
  Paper,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { ParticipateRadio } from "./inputForms/participateRadio";
import { SexPullDown } from "./inputForms/pullDown";
import { PayPayIdInput, InputTextArea, PayPayNameInput } from "./inputForms/inputText";
import { InputCalender } from "./inputForms/birthdayInput";

// 入力項目の定義
let inputItems = {
  reserveCls: {
    title: "予約内容*",
    value: "",
  },
  sex: {
    title: "性別",
    value: "",
  },
  birthday: {
    title: "誕生日(年齢)*",
    value: "",
  },
  paypayId: {
    title: "PayPayIDまたはPayPay名*",
    value: "",
  },
  answer: {
    title: "質問の回答",
    value: "",
  },
  message: {
    title: "備考",
    value: "",
  },
};

// InputFormatコンポーネント
export const InputFormat = ({ inputValue, formRef }: any) => {
  // inputValueの更新を反映
  useEffect(() => {
    inputItems.reserveCls.value = inputValue.reserveCls;
    inputItems.sex.value = inputValue.sex;
    inputItems.birthday.value = inputValue.birthday;
    inputItems.paypayId.value = inputValue.paypayId;
    inputItems.answer.value = inputValue.answer;
    inputItems.message.value = inputValue.message;
  }, [inputValue]);
  
  // レスポンシブ対応
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
    <Paper
      sx={{
        border: '1px solid #DDDDDD',
        padding: isMobile ? '8px' : '16px',
        margin: isMobile ? "10px auto" : "20px auto"
      }}
    >
      <Typography
        sx={{
          color: '#fff',
          backgroundColor: '#3f51b5',
          padding: isMobile ? '8px' : '10px',
          textAlign: 'center',
          borderRadius: '5px',
        }}
      >
        予約内容入力
      </Typography>
      <Grid container spacing={2}>
        {/* 予約内容区分 */}
        <Grid item xs={12}>
          <ParticipateRadio
            inputItem={inputValue.reserveCls}
            inputRef={formRef.reserveCls}
            reserveType={inputValue.reserveType}
            reserveStatus={inputValue.reserveStatus}
          />
        </Grid>

        {/* 性別 */}
        <Grid item xs={12} sm={6}>
          <SexPullDown inputItem={inputValue.sex} inputRef={formRef.sex} />
        </Grid>

        {/* 誕生日 */}
        <Grid item xs={12} sm={6}>
          <InputCalender inputItem={inputValue.birthday} inputRef={formRef.birthday} />
        </Grid>

        {/* PayPay名 */}
        <Grid item xs={12} sm={6}>
          <PayPayNameInput inputItem={inputValue.paypayName} inputRef={formRef.paypayName} />
        </Grid>

        {/* PayPay ID */}
        <Grid item xs={12} sm={6}>
          <PayPayIdInput inputItem={inputValue.paypayId} inputRef={formRef.paypayId} />
        </Grid>

        {/* 備考 */}
        <Grid item xs={12}>
          <InputTextArea inputItem={inputValue.message} inputRef={formRef.message} />
        </Grid>
      </Grid>
    </Paper>
    </>
  );
};
